import React, { useRef, useEffect, useContext } from 'react';
import { Button, useAccordionToggle, AccordionContext } from 'react-bootstrap';

export default function CustomToggle({ eventKey }) {
  const iconRef = useRef(null);
  const currentEventKey = useContext(AccordionContext);

  // Check if the accordion item is already open
  const isInitiallyOpen = currentEventKey === eventKey;

  useEffect(() => {
    if (iconRef.current) {
      if (isInitiallyOpen) {
        iconRef.current.classList.add('inverse'); // Apply inverse if initially open
      } else {
        iconRef.current.classList.remove('inverse');
      }
    }
  }, [isInitiallyOpen]);

  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    if (iconRef.current) {
      iconRef.current.classList.toggle('inverse'); // Toggle on click
    }
  });

  return (
    <Button variant="link" className="btn-toggle accordion-toggle-icon" onClick={decoratedOnClick}>
      <i ref={iconRef} className="icon-new-down-arrow-icon" />
    </Button>
  );
}
